import React, { forwardRef } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

export default function FilterDropdown({ label, active, width = 'w-64', panel }) {
  return (
    <ClickAwayComponent
      Component={forwardRef(({ handleClick, open }, ref) => (
        <div className="relative" ref={ref}>
          <button
            type="button"
            onClick={handleClick}
            className={`flex items-center gap-2 rounded-full h-9 px-3 text-sm whitespace-nowrap ${active ? 'bg-focus text-primary' : 'bg-background text-dark-blue'}`}
          >
            {active ?? label}
            <UIcons.UilAngleDown size={16} className={open ? 'rotate-180' : ''} />
          </button>

          {
            open && (
              <div className={`absolute left-0 top-11 z-20 ${width} bg-white border border-border-lines rounded-xl shadow-lg p-4`}>
                {panel({ close: handleClick })}
              </div>
            )
          }
        </div>
      ))}
    />
  )
}
